<template>
  <div class="login-information">
    <img src="../../assets/images/login-logo.png" class="login-logo cup" @click="$navigate('/index/index', null, false)"
      alt="" />

      <template v-if="language=='zh'">
        <img :src="require('../../assets/images/logintext-zh.png')" class="login-textimg" alt="">
      </template>
      <template v-if="language=='en'">
        <img :src="require('../../assets/images/logintext-en.png')" class="login-textimg" alt="">
      </template>

    <div class="login-information-box df fdc">
      <div class="title fn">{{ $t("请输入您的个人信息") }}</div>

      <div class="information-container mt-24 f1">
        <el-form :model="formdata" :rules="rules" ref="form">
          <el-form-item prop="user_nick_name">
            <el-input v-model="formdata.user_nick_name" :placeholder="$t('昵称')"></el-input>
          </el-form-item>

          <el-form-item prop="register_country">
            <!-- 地区 -->
            <el-select filterable v-model="formdata.register_country" :placeholder="$t('国家/区域')" style="width: 100%"
              @change="handlerCountry">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in register_country"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="register_province"  v-if="currentLang=='zh'">
            <!-- 省份 -->
            <el-select filterable v-model="formdata.register_province" :placeholder="$t('省份/州')" style="width: 100%"
              :disabled="register_province.length > 0 ? false : true">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in register_province"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="user_company">
            <!-- 公司名称 -->
            <el-input v-model="formdata.user_company" :placeholder="$t('公司名称')"></el-input>
          </el-form-item>

          <el-form-item prop="user_industry">
            <!-- 行业 -->
            <el-select v-model="formdata.user_industry" :placeholder="$t('行业')" style="width: 100%">
              <el-option :label="items.label" :value=String(items.value) v-for="(items, index) in industryList"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="user_job">
            <!-- 职位 -->
            <el-select v-model="formdata.user_job" :placeholder="$t('职位')" style="width: 100%">
              <el-option :label="items.label" :value=String(items.value) v-for="(items, index) in jobList"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="user_role">
            <!-- 角色 -->
          
            <el-select v-model="formdata.user_role" :placeholder="$t('请选择角色')" style="width: 100%" multiple
              @change="roleHandle($event)">
              <el-option :label="items.label" :value="items.value" v-for="(items, index) in roleList"
                :key="items.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="user_contact_email" v-if="formdata.register_type == 1">
            <!-- 邮箱 -->
            <el-input v-model="formdata.user_contact_email" :placeholder="$t('邮箱')"></el-input>
          </el-form-item>

          <el-form-item prop="user_contact_mobile" v-if="formdata.register_type == 2">
            <!-- 手机号 -->
            <el-input v-model="formdata.user_contact_mobile" :placeholder="$t('联系电话')"></el-input>
          </el-form-item>
          <!-- 隐私协议 -->
          <div class="verify-box">
            <el-checkbox v-model="privacy" class="checkbox-circle">{{
              $t("我已阅读并同意")
            }}</el-checkbox>
            <span @click="handleragreement($event, 1)">
              {{ $t("隐私协议") }}
            </span>
            {{ $t("与") }}
            <span @click="handleragreement($event, 2)">
              {{ $t("用户注册协议") }}
            </span>
          </div>
          <!-- 确定按钮 -->
          
        </el-form>
      </div>
      <div class="mt-24">
            <el-button type="primary" class="sub-button" @click="handleSubmit" :loading="loading">{{ $t("确定")
            }}</el-button>
          </div>
      <div class="mt-24">
            <el-button class="sub-info" @click="cancelLogin">{{ $t("取消登录")}}</el-button>
          </div>
    </div>

    <!-- 隐私协议 -->
    <el-dialog :title="activityInfo.privacyPro.tsap_title" :visible.sync="privacyVisible" width="55%">
      <div class="dialog-content">
        <span v-html="activityInfo.privacyPro.tsap_content"></span>
      </div>
    </el-dialog>

    <el-dialog :title="activityInfo.registerPro.tsap_title" :visible.sync="registerVisible" width="55%">
      <div class="dialog-content">
        <span v-html="activityInfo.registerPro.tsap_content"></span>
      </div>
      
    </el-dialog>
  </div>
</template>

<script>
import { userFirstEditView, user_first_edit, getDistrict } from "@api/user";
import { getAreacode } from "@api/questionnaire";
import { random } from "lodash";
import Cookies from 'js-cookie';
export default {
  data() {
    return {
      currentLang:localStorage.getItem('currentLanguage'),
      loading: false,
      apply_site: "protal",
      tws_id: 1,
      userinfo: [],
      jobList: [],
      register_country: [],
      register_province: [],
      roleList: [],
      industryList: [],

      privacy: true, //是否勾选 隐私协议
      formdata: {
        user_nick_name: "", // 姓名
        // 地区
        register_country: "",
        // 省份
        register_province: "",
        user_company: "", // 公司名称
        user_industry: "", // 行业
        user_job: "", // 职位
        user_role: [], // 角色
        user_contact_email: "", // 邮箱
        user_contact_mobile: "", // 手机号
      },
      rules: {
        user_nick_name: [
          { required: true, message: this.$t("请输入昵称"), trigger: "blur" },
        ],
        register_country: [
          {
            required: true,
            message: this.$t("请选择国家/区域"),
            trigger: "change",
          },
        ],
        user_company: [
          {
            required: true,
            message: this.$t("请输入公司名称"),
            trigger: "blur",
          },
        ],
        user_industry: [
          { required: true, message: this.$t("请选择行业"), trigger: "change" },
        ],
        user_job: [
          { required: true, message: this.$t("请选择职位"), trigger: "change" },
        ],
        user_role: [
          { required: true, message: this.$t("请选择角色"), trigger: "change" },
        ],
        user_contact_email: [
          {
            required: true,
            message: this.$t("请输入联系邮箱"),
            trigger: "blur",
          },
        ],
        user_contact_mobile: [
          {
            required: true,
            message: this.$t("请输入联系手机号"),
            trigger: "blur",
          },
        ],
      },

      // 隐私协议
      privacyVisible: false,
      registerVisible: false,

      // 隐私协议
      activityInfo: {
        register_type: 1,
        privacyPro: {
          tsap_title: " 华为技术网站隐私协议",
          tsap_content: "",
        },
        registerPro: {
          tsap_title: " 华为公司用户注册协议",
          tsap_content: "",
        },
      },

      // 获取当前语言
      language: this.$i18n.locale,
      callback: '',
    };
  },

  mounted() {
    this.getUserFirstEditView();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.callback = urlParams.get("callback");
  },
  methods: {
    //取消登录
    cancelLogin(){
      Cookies.remove('accessToken');
      this.$navigate('/index/index', null, false)
    },
    roleHandle(e) {
      // this.$nextTick(()=>{
      //   this.formdata.user_role=e;
      // })
      // this.formdata.user_role=JSON.parse(JSON.stringify(e));
      console.log(this.formdata.user_role)
    },
    async getUserFirstEditView() {

      const res = await userFirstEditView();
      if (res.status == 200) {
        this.formdata = {
          
          register_type: res.data.userinfo.register_type,
          register_country: res.data.userinfo.register_country,
          register_province: res.data.userinfo.register_province,
          user_company: res.data.userinfo.user_company,
          user_contact_email: res.data.userinfo.user_contact_email,
          user_contact_mobile: res.data.userinfo.user_contact_mobile,
          user_industry: res.data.userinfo.user_industry,
          user_job: res.data.userinfo.user_job,
          //user_nick_name: res.data.userinfo.user_nick_name,   去掉昵称的默认填写，让用户必填
          user_role: res.data.userinfo.user_role ? res.data.userinfo.user_role.split(',').map(Number) : [],
        };

        this.formdata.register_country = "";
        this.formdata.register_province = "";
        this.formdata.user_industry = "";

        this.jobList = res.data.user_job_options;
        this.register_country = res.data.country_list;
        this.roleList = res.data.user_role_options;
        this.industryList = res.data.user_industry_options;

        this.activityInfo.privacyPro = res.data.privacyPro;
        this.activityInfo.registerPro = res.data.registerPro;
      }
    },

    handlerCountry() {
      // 更改洲后清空后续选项
      this.formdata.register_province = "";
      // 获取新的国家列表
      this.getcitytArea(this.formdata.register_country);
    },

    async getcitytArea(value) {
      let res = await getDistrict(3, value);
      if (res.status == 200) {
        this.register_province = res.data;
      }
    },

    handleSubmit() {
      this.loading = true;
      // 验证
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.privacy) {
            // this.formdata.user_role = this.formdata.user_role.join(',');

            let newformdata={...this.formdata};
            newformdata.user_role=newformdata.user_role.join(',');
            let res = await user_first_edit(newformdata);
            if(res.status!=200){
              this.loading = false;
              return false;
            }

            setTimeout(() => {
              if (this.callback == null || this.callback == undefined || this.callback == 'null') {
                return this.$navigate('/index/index', null, false);
              } else {
                // console.log('来这里咯');
                // return false;
                return window.location.href = this.callback;
              }
            }, 1000);
          } else {
            this.loading = false;
            this.$message.error(this.$t("请同意并勾选协议"));
            return false;
          }
        } else {
          this.loading = false;
        }
      });
    },

    // 隐私协议
    handleragreement(event, type) {
      event.stopPropagation();
      if (type == 1) {
        this.privacyVisible = true;
      } else if (type == 2) {
        this.registerVisible = true;
      }
    },

    //获取地址中的callback参数
    getCallbackUrl(url = "") {
      // 获取当前页面的 URL
      var currentUrl = window.location.href;
      var urlParams = new URLSearchParams(new URL(currentUrl).search);
      var callback = urlParams.get("callback");
      return callback ? callback : url;
    },

    // 获取 cookie 字符串
    getCookieValue(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep() {
  .el-dialog__body {
    max-height: calc(70vh - 54px);
    margin-bottom: 24px;
    padding: 24px 0;
    // overflow-y: scroll;
    .dialog-content {
      width: 100%;
      max-height: calc(70vh - 102px);
      padding: 0 24px;
      overflow: hidden;
      overflow-y: scroll;

      // 设置滚动条样式
      &::-webkit-scrollbar {
        width: 4px;
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #B7251E;
      }
    }
  }
  .el-input__inner::placeholder {
    color: #aeaeae !important;
    font-size: 14px !important;
  }
}

* {
  font-family: "harmonyos";
  font-weight: 400;
}

.information-container {
  width: calc(100% + 60px);
  padding-right: 60px;
  overflow: hidden;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    // 窄度
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #B7251E;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: rgba($color: #000000, $alpha: 0.01);
    border-radius: 4px;
  }
}

.verify-box {
  font-size: 12px;
  line-height: 22px;
  color: #aeaeae;

  span {
    color: #b7251e;
    cursor: pointer;
  }
}

.checkbox-circle {
  ::v-deep() {
    .el-checkbox__inner {
      width: 18px;
      height: 18px;
      border-radius: 50%;
    }

    .el-checkbox__inner::after {
      width: 4px;
      left: 6px;
      top: 3px;
    }

    .el-checkbox__label {
      font-size: 12px;
      line-height: 22px;
      color: #aeaeae;
      padding-left: 6px;
    }
  }
}

.sub-button {
  width: 100%;
  height: 40px;
  border-radius: 20px;
  /* #B7251E */
  background: rgb(183, 37, 30);
}

.sub-info {
  width: 100%;
  height: 40px;
  border-radius: 20px;
  /* #B7251E */
  // background: rgb(183, 37, 30);
}

::v-deep() {
  .el-input__inner {
    border: none;
    background: transparent;
  }

  .el-form-item {
    border-radius: 8px;
    background: rgb(245, 248, 255);
    margin-bottom: 16px;
  }
}

.login-information {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/login-bg.png") no-repeat left bottom;
  background-size: cover;
  background-color: #fff;
  position: relative;

  .login-logo {
    position: absolute;
    left: 40px;
    top: 40px;
  }

  .login-textimg {
    width: 44.43%;
    position: absolute;
    left: 120px;
    top: 30%;
  }

  .login-information-box {
    width: 520px;
    height: 764px;
    max-height: 92vh;
    border-radius: 16px;
    box-shadow: 0px 8px 24px 8px rgba(28, 57, 123, 0.08);
    background: rgb(255, 255, 255);
    position: absolute;
    right: 120px;
    top: 50%;
    transform: translateY(-50%);
    padding: 60px 60px 40px;

    .title {
      color: rgb(0, 0, 0);
      line-height: 28px;
      font-size: 24px;
    }
  }
}
</style>